import React from 'react'
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../redux/store';
import { MonthObj, getOrders, unselectMonth } from '../../redux/orderSlice';
import { monthNames } from '../../names';

export const MonthSwitcher = ({months}) => {

    const dispatch = useDispatch();

    const selectMonthHandler = (e, month) => {
        const isAlreadyActive = months.some(m => (m.month === month) && m.active)
        isAlreadyActive 
        ? dispatch(unselectMonth({month, multi: e.ctrlKey}))
        : dispatch(getOrders({month, multi: e.ctrlKey}))

    };
    
    return (
        <div className="month-switcher">
            {months.map((m) => (
                <button
                    className={`button dark-theme-bg0 ${m.active ? 'active' : ''} ${m.loaded ? 'loaded' : ''}`}
                    onClick={(e) => selectMonthHandler(e, m.month)}
                    key={m.month}>
                    {monthNames[+m.month.split('-')[1] - 1]} {m.month.split('-')[0]}
                </button>
            ))}
        </div>
    );
}
